import { cookie } from './lister-utilities';

export const getDefaultViewFormat = (IsDealsPage) => {
	return (
		cookie(IsDealsPage ? 'DealsViewFormat' : 'ListerViewFormat').get() ??
		(IsDealsPage ? 'grid' : 'list')
	);
};
